import { render, staticRenderFns } from "./ProductStoreChannelStatusToggleCmp.vue?vue&type=template&id=a89aecc2&scoped=true&"
import script from "./ProductStoreChannelStatusToggleCmp.vue?vue&type=script&lang=js&"
export * from "./ProductStoreChannelStatusToggleCmp.vue?vue&type=script&lang=js&"
import style0 from "./ProductStoreChannelStatusToggleCmp.vue?vue&type=style&index=0&id=a89aecc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89aecc2",
  null
  
)

export default component.exports